module.exports = __webpack_public_path__ + "static/media/love.a3855cd5.png";